import { render, staticRenderFns } from "./StakingDaoInstanceList.vue?vue&type=template&id=2ebfca9a&"
import script from "./StakingDaoInstanceList.vue?vue&type=script&lang=js&"
export * from "./StakingDaoInstanceList.vue?vue&type=script&lang=js&"
import style0 from "./StakingDaoInstanceList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports